import * as React from 'react';

const SvgRowBelow = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="8.5"
      y="21"
      width="7"
      height="7"
      rx="2"
      transform="rotate(-90 8.5 21)"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      opacity="0.12"
      x="3"
      y="10"
      width="7"
      height="18"
      rx="2"
      transform="rotate(-90 3 10)"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <rect
      x="3"
      y="10"
      width="7"
      height="18"
      rx="2"
      transform="rotate(-90 3 10)"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
);

export default SvgRowBelow;
